import { createGlobalStyle } from "styled-components";
import { korTheme, engTheme, vietTheme,thaiTheme  } from './theme';

const GlobalStyle = createGlobalStyle`
    .bottomNav .navWrapper {background-color: ${(props) => props.theme.backgroundColor};}
    .bottomNav .navWrapper .navLink {color: ${(props) => props.theme.bottomNavText};}
    .bottomNav .navLink.active {color: ${(props) => props.theme.bottomNavTextActive};}
    .bottomNav .navLink.active .txt:before {background-color: ${(props) => props.theme.bottomNavTextActive};}
    .bottomNav .navLink img {filter: ${(props) => props.theme.saleeIcon};}
    .bottomNav .navLink.active img {filter: ${(props) => props.theme.saleeIcon};}

    .cartPage .floatBtnWr .orderBtn,
    .floatBtn, .orgB, .buyBtn {
        background-color: ${(props) => props.theme.org} !important; 
        color: ${(props) => props.theme.orgText} !important; 
        font-weight: 600;
    }
    .bgBlue:after {background: ${(props) => props.theme.backCont}; }
`;

export default GlobalStyle;